import axios from "axios";
import { getQueryString } from "@/utils/tools";

const siteId = getQueryString("site_id");

const baseReq = axios.create({
  baseURL: `/platform/api/v1/plugin/tk`,
  timeout: 5000
});

baseReq.interceptors.response.use(res => {
  if (res.data.code === 200) {
    return res.data.data;
  } else {
    return Promise.reject(res.data);
  }
});

/**
 * 获取域名列表
 * @param params 
 */
export function getDomainList( params ) {
  return baseReq.get(`/${siteId}/domains`, { params })
}

/**
 * 获取域名池信息
 * @param userId
 */
export function getDomainPool( userId ) {
  return baseReq.get(`/${siteId}/domainPool`, {
    params: {
      userId
    }
  })
}

/**
 * 获取推荐域名
 * @param userId
 */
export function getRecommendedDomain(userId) {
  return baseReq.get(`/${siteId}/domains/recommend`, {
    params: {
      userId
    }
  })
}

/**
 * 域名防洪推送查询
 */
export function getPostSetting() {
  return baseReq.get(`/${siteId}/domains/push`)
}

/**
 * 域名防洪推送添加或者修改
 */
export function savePostSetting(data) {
  return baseReq.post(`/domains/push`, { 
      siteId,
      ...data
    }
  )
}

/**
 * 域名推送地址有效性检测
 */
export function checkPushUrl(pushUrl) {
  return baseReq.get(`/domains/pushurl/check`, {
    params: {
      pushUrl
    }
  })
}